import React from 'react';
import { Container, Flex, Stack } from '@grubhubprod/gh-cookbook-react';
import Table from 'src/components/Table/Table';
import { NoResultsMsg } from 'src/components/Table/NoResultsMsg';
import { ChildAccountTableErrors } from 'src/components/enterprise/Parents/Children/ParentChildAccountController/ChildAccountTable/ChildAccountTableErrors/ChildAccountTableErrors';
import { FIVE_ROW_HEIGHT } from 'src/components/enterprise/Parents/constants';
import { ChildAccountTableCounter } from './ChildAccountTableCounter/ChildAccountTableCounter';
import { ChildAccountTableHeader } from './ChildAccountTableHeader/ChildAccountTableHeader';

export interface ChildAccountTableProps {
  children: React.ReactNode;
  currentNumberOfChildAccounts: number;
  maximumAllowedAccounts: number;
  tableErrorsText?: string;
}

export default function ChildAccountTable({
  children,
  currentNumberOfChildAccounts,
  maximumAllowedAccounts,
  tableErrorsText,
}: ChildAccountTableProps): JSX.Element {
  const displayNoChildAccounts = () => {
    return <NoResultsMsg message="You haven't added any child accounts yet." />;
  };

  return (
    <Container>
      <Stack y="sm">
        <Flex justifyContent="space-between" alignItems="center">
          <Stack>
            <ChildAccountTableErrors>{tableErrorsText}</ChildAccountTableErrors>
          </Stack>
          <ChildAccountTableCounter
            currentNumberOfAccounts={currentNumberOfChildAccounts}
            maximumAllowedAccounts={maximumAllowedAccounts}
          />
        </Flex>
      </Stack>
      <Stack>
        <Table
          bodyMaxHeight={FIVE_ROW_HEIGHT}
          header={() => <ChildAccountTableHeader />}
          body={() =>
            currentNumberOfChildAccounts > 0
              ? children
              : displayNoChildAccounts()
          }
          showFooter={false}
        />
      </Stack>
    </Container>
  );
}
